export class Terminal{
    id: string;
    codigoTerminal: string;
    codigoLetras: string;
    nombre: string;
    direccion: string;
}